export const firebaseConfig = {
	apiKey: "AIzaSyAVEd2aetzFEdEPo4npkULK0tOoJ-htyGI",
	authDomain: "verris-hillsong-tech.firebaseapp.com",
	databaseURL: "https://verris-hillsong-tech.firebaseio.com",
	projectId: "verris-hillsong-tech",
	storageBucket: "gs://verris-client-images",
	messagingSenderId: "407939573407",
};
